
        Component.define('filter', (el, params) => {
            const $el = $(el);

$('select', el).on('change', function(){
    const $this = $(this);
    const val = $(this).val();

    $('[data-category]').addClass('hide');
    $('[data-category] [data-animated]').removeAttr('style');
    $('[data-category] [data-animated]').removeAttr('data-animated');

    if(val){
        $('[data-category="'+ val +'"]').removeClass('hide');
    } else {
        $('[data-category]').removeClass('hide');
    }

    $document.trigger('scroll');
});

        });